import anime from 'animejs/lib/anime.min'

$(".txt_wave").each(function (index) {
    let text = $(this).html();
    let newText = text.replace(/<\/?[^>]+(>|$)/g, "").replace(/\S+/g, "<span class='letter'>$&</span>");
    $(this).html(newText);
    if (text) $(this).append(`<span class="original-text">`+text+`</span>`)
});


export function animTxtWave(element, duration = 950) {
    let _element = element.find('.anim_txt .letter').get()
    anime.timeline({loop: false}).add({
        targets   : '.anim_txt .letter',
        translateY: [20, 0],
        rotate : [20,0],
		scale :[0,1],
        // translateZ: 0,
        opacity   : [0, 1],
        easing    : "spring",
        duration  : duration,
        delay     : (el, i) => 70  * i,
        complete: () => {
            let text = element.find('.original-text').html()
            if (text) element.html(text)
        }
    }).add({
        targets: '.anim_txt .line1',
        scaleY: [0,1],
        opacity: [0.5,1],
        easing: "easeOutExpo",
        duration: 800,
        // offset: '-=875',
        delay: (el, i, l) => 80 * (l - i)
    },'400').add({
        targets: '.anim_txt .line2',
        scaleX: [0,1],
        opacity: [0.5,1],
        easing: "easeOutExpo",
        duration: 800,
        // offset: '-=875',
        delay: (el, i, l) => 80 * (l - i)
    },'800')
}



anime({
    targets: '.compentece',
    translateX: 250
});
